import { AxiosError, AxiosResponse } from "axios";
import { IGetListRequest, IResponse, IServerError } from "../../models";
import {
  ITrustBank,
  ITrustBankListPayload,
} from "../../models/DirectDeposit/TrustBank";

import http from "../../common/http-commons";

export const TrustBankService = {
  getTrustBanksList: async (
    data: IGetListRequest,
  ): Promise<
    ITrustBankListPayload | IServerError | IResponse | ITrustBankListPayload[]
  > => {
    try {
      const response: AxiosResponse<ITrustBankListPayload> =
        await http.get<ITrustBankListPayload>(
          "/v1/trust-bank-setup/?" +
            "&order_by=" +
            data.order_by +
            "&order_direction=" +
            data.order_direction +
            "&page=" +
            data.page +
            "&size=" +
            data.size +
            "&search_query=" +
            data.search_query,
        );

      if (response.status === 200) {
        return response.data;
      } else if (response.status === 400) {
        return {
          status: false,
          message: "Bad Request.",
          error: true,
        };
      } else if (response.status === 500) {
        return {
          status: false,
          message: "Something went wrong.",
          error: true,
        };
      }
      return {
        status: false,
        message: "Something went wrong please try again later.",
      };
    } catch (error) {
      const axiosError = error as AxiosError;
      console.error("An error occurred:", axiosError);
      const errorMessage =
        axiosError.response && typeof axiosError.response.data === "string"
          ? axiosError.response.data
          : "Unknown error";
      return { status: false, message: errorMessage, error: true };
    }
    // const fixedResponse: any = {
    //   page: 1,
    //   size: 50,
    //   total: 1,
    //   items: [
    //     {
    //       id: "0b6cec0e-0987-445a-b291-5a4d61ec0093",
    //       firstName: "Allan",
    //       lastName: "Fefergrad",
    //       fullName: "Allan Fefergrad",
    //       accTitle: "AF Accounting",
    //       email: "AfAccounting@gmail.com",
    //       province: "Alberta",
    //       city: "Toronto",
    //       country: "CAN",
    //       postalCode: "A5D5D5",
    //       phoneNo: "(123) 456-7890",
    //       ext: "123",
    //       website: "11",
    //       status: "Active",
    //     },
    //     {
    //       id: "504d04da-25bd-4193-8f4c-a7b296b296bb",
    //       firstName: "Brent",
    //       lastName: "Miller",
    //       fullName: "Brent Miller",
    //       accTitle: "ALTAML Inc.",
    //       email: "ALTAMLInc@gmail.com",
    //       province: "Alberta",
    //       city: "Toronto",
    //       country: "CAN",
    //       postalCode: "A5D5D5",
    //       phoneNo: "(123) 456-0000",
    //       ext: null,
    //       website: "",
    //       status: "Active",
    //     },
    //     {
    //       id: "a14f3906-9e69-4a9f-bcc7-e1944b255a28",
    //       firstName: "Jose A",
    //       lastName: "Rodriguez",
    //       fullName: "Jose A Rodriguez",
    //       accTitle: "All Work Jobs Inc",
    //       email: "AllWorkJobsInc@gmail.com",
    //       province: "Alberta",
    //       city: "Toronto",
    //       country: "CAN",
    //       postalCode: "A5D5D5",
    //       phoneNo: "(123) 000-0000",
    //       ext: null,
    //       website: "",
    //       status: "Active",
    //     },
    //     {
    //       id: "55d127fe-26e4-4c8d-8144-62c06a872d41",
    //       firstName: "Boris",
    //       lastName: "Baranov",
    //       fullName: "Boris Baranov",
    //       accTitle: "Baranov CPA Professional Corporation",
    //       email: "BaranovCPA@gmail.com",
    //       province: "Alberta",
    //       city: "Toronto",
    //       country: "CAN",
    //       postalCode: "A5D5D5",
    //       phoneNo: "(999) 999-9999",
    //       ext: null,
    //       website: "",
    //       status: "Active",
    //     },
    //     {
    //       id: "705f5509-a2c5-4505-ada7-b94f45b10646",
    //       firstName: "BEN",
    //       lastName: "SAGAR",
    //       fullName: "BEN SAGAR",
    //       accTitle: "CANAMEX INC.",
    //       email: "canamexInc.@hotmail.com",
    //       province: "Alberta",
    //       city: "Toronto",
    //       country: "CAN",
    //       postalCode: "A1A1A1",
    //       phoneNo: "(123) 456-7890",
    //       ext: null,
    //       website: "test.com",
    //       status: "Active",
    //     },
    //     {
    //       id: "8fe63e30-b098-410d-9981-df56e7835aa4",
    //       firstName: "Farooq",
    //       lastName: "Khalid",
    //       fullName: "Farooq Khalid",
    //       accTitle: "Decent Accounting",
    //       email: "DecentAccounting@hotmail.com",
    //       province: "Alberta",
    //       city: "Toranto",
    //       country: "CAN",
    //       postalCode: "A4A4A4",
    //       phoneNo: "(123) 456-7777",
    //       ext: null,
    //       website: "",
    //       status: "Active",
    //     },
    //     {
    //       id: "3496271c-fee0-4591-9c18-1edcaad40ec5",
    //       firstName: "Fabien",
    //       lastName: "Gendron",
    //       fullName: "Fabien Gendron",
    //       accTitle: "Duncan & Co CPAse",
    //       email: "DuncanCPAse@gmail.com",
    //       province: "Alberta",
    //       city: "Toronto",
    //       country: "CAN",
    //       postalCode: "A5D5D5",
    //       phoneNo: "(123) 456-8888",
    //       ext: null,
    //       website: "",
    //       status: "Active",
    //     },
    //     {
    //       id: "288f7ee8-fdc0-4d26-a1ff-a5dfd04ea85d",
    //       firstName: "Direct",
    //       lastName: "Clients",
    //       fullName: "Direct Clients",
    //       accTitle: "Websential Inc.",
    //       email: "WebsentialInc@gmail.com",
    //       province: "Alberta",
    //       city: "Toronto",
    //       country: "CAN",
    //       postalCode: "A5D5D5",
    //       phoneNo: "(123) 145-3030",
    //       ext: null,
    //       website: "",
    //       status: "Active",
    //     },
    //   ],
    //   keyField: {
    //     field: "name",
    //     templateUrl: "/t4-slips/{id}",
    //   },
    //   headerColumns: [
    //     {
    //       field: "fullName",
    //       headerName: "Name",
    //       description: "",
    //       flex: 1,
    //       hide: false,
    //       hideable: false,
    //       sortable: false,
    //       sortingOrder: "asc",
    //       resizable: false,
    //       type: "text",
    //       align: "left",
    //       headerAlign: "left",
    //       hideSortIcons: false,
    //       disableColumnMenu: true,
    //       disableReorder: true,
    //       disableExport: true,
    //       maskable: false,
    //       isFixed: true,
    //       sequence: 0,
    //       frozenColumn: true,
    //       footer: null,
    //       minWidth: 100,
    //       alignFrozen: null,
    //     },
    //     {
    //       field: "accTitle",
    //       headerName: "Account Title",
    //       description: "",
    //       flex: 1,
    //       hide: false,
    //       hideable: false,
    //       sortable: false,
    //       sortingOrder: "asc",
    //       resizable: false,
    //       type: "text",
    //       align: "left",
    //       headerAlign: "left",
    //       hideSortIcons: false,
    //       disableColumnMenu: true,
    //       disableReorder: true,
    //       disableExport: true,
    //       maskable: false,
    //       isFixed: true,
    //       sequence: 1,
    //       frozenColumn: false,
    //       footer: null,
    //       minWidth: 60,
    //       alignFrozen: null,
    //     },
    //     {
    //       field: "email",
    //       headerName: "Email",
    //       description: "",
    //       flex: 1,
    //       hide: false,
    //       hideable: false,
    //       sortable: false,
    //       sortingOrder: "asc",
    //       resizable: false,
    //       type: "string",
    //       align: "left",
    //       headerAlign: "left",
    //       hideSortIcons: false,
    //       disableColumnMenu: true,
    //       disableReorder: true,
    //       disableExport: true,
    //       maskable: false,
    //       isFixed: true,
    //       sequence: 2,
    //       frozenColumn: false,
    //       footer: null,
    //     },
    //     {
    //       field: "phoneNo",
    //       headerName: "Phone",
    //       description: "",
    //       flex: 1,
    //       hide: false,
    //       hideable: false,
    //       sortable: false,
    //       sortingOrder: "asc",
    //       resizable: false,
    //       type: "string",
    //       align: "left",
    //       headerAlign: "left",
    //       hideSortIcons: false,
    //       disableColumnMenu: true,
    //       disableReorder: true,
    //       disableExport: true,
    //       maskable: false,
    //       isFixed: true,
    //       sequence: 3,
    //       frozenColumn: false,
    //       footer: null,
    //     },
    //     {
    //       field: "city",
    //       headerName: "City",
    //       description: "",
    //       flex: 1,
    //       hide: false,
    //       hideable: false,
    //       sortable: false,
    //       sortingOrder: "asc",
    //       resizable: false,
    //       type: "string",
    //       align: "left",
    //       headerAlign: "left",
    //       hideSortIcons: false,
    //       disableColumnMenu: true,
    //       disableReorder: true,
    //       disableExport: true,
    //       maskable: false,
    //       isFixed: true,
    //       sequence: 4,
    //       frozenColumn: false,
    //       footer: null,
    //     },
    //     {
    //       field: "status",
    //       headerName: "Status",
    //       description: "",
    //       flex: 1,
    //       hide: false,
    //       hideable: false,
    //       sortable: false,
    //       sortingOrder: "asc",
    //       resizable: false,
    //       type: "string",
    //       align: "left",
    //       headerAlign: "left",
    //       hideSortIcons: false,
    //       disableColumnMenu: true,
    //       disableReorder: true,
    //       disableExport: true,
    //       maskable: false,
    //       isFixed: true,
    //       sequence: 5,
    //       frozenColumn: false,
    //       footer: null,
    //     },
    //   ],
    // };

    // return new Promise((resolve) =>
    //   setTimeout(() => resolve(fixedResponse), 1000),
    // );
  },

  getTrustBankDataById: async (
    id: string | undefined,
    navigateToLogout: (path: string) => void,
  ): Promise<ITrustBank | IServerError | IResponse | null | any> => {
    if (!id) return null;
    try {
      const response: AxiosResponse<ITrustBank> = await http.get<ITrustBank>(
        // `/v1/employee-bank/${id}/`
        `/v1/trust-bank-setup/${id}/`,
      );

      if (response.status === 200) {
        return response.data;
      } else if (response.status === 500) {
        return {
          status: false,
          message: "Something went wrong.",
          error: true,
        };
      }

      return {
        status: false,
        message: "Something went wrong please try again later.",
      };
    } catch (error) {
      const axiosError = error as AxiosError;
      console.error("An error occurred:", axiosError);
      const errorMessage =
        axiosError.response && typeof axiosError.response.data === "string"
          ? axiosError.response.data
          : "Unknown error";
      if (axiosError && axiosError.status === 401) {
        navigateToLogout("/logout");
        return {
          status: false,
          message: "UnAuthrized",
        };
      } else {
        return {
          status: false,
          message: errorMessage,
        };
      }
    }
  },
  createTrustBank: async (
    requestPayload: any,
  ): Promise<ITrustBank | IServerError | IResponse | any> => {
    if (requestPayload.payload.id) {
      try {
        const response: AxiosResponse<any> = await http.put<ITrustBank>(
          `/v1/trust-bank-setup/${requestPayload.payload.id}/`,
          requestPayload.payload,
        );

        if (response.status === 200) {
          return response;
        } else if (response.status === 400) {
          return response.data;
        } else if (response.status === 404) {
          return response.data;
        } else if (response.status === 500) {
          return {
            status: false,
            message: "Something went wrong.",
            error: true,
          };
        }
      } catch (error) {
        const axiosError = error as AxiosError;
        console.error("An error occurred:", axiosError);
        const errorMessage =
          axiosError.response && typeof axiosError.response.data === "string"
            ? axiosError.response.data
            : "Unknown error";
        if (axiosError && axiosError.status === 401) {
          requestPayload.navigateToLogout("/logout");
          return {
            status: false,
            message: "UnAuthrized",
          };
        } else {
          return {
            status: false,
            message: errorMessage,
          };
        }
      }
    }

    try {
      const response: AxiosResponse<any> = await http.post<ITrustBank>(
        "/v1/trust-bank-setup/add-trust-bank",
        requestPayload.payload,
      );

      if (response.status === 201) {
        return response;
      } else if (response.status === 400) {
        return response.data;
      } else if (response.status === 404) {
        return response.data;
      } else if (response.status === 500) {
        return {
          status: false,
          message: "Something went wrong.",
          error: true,
        };
      }

      return {
        status: false,
        message: "Something went wrong please try again later.",
      };
    } catch (error) {
      const axiosError = error as AxiosError;
      console.error("An error occurred:", axiosError);
      const errorMessage =
        axiosError.response && typeof axiosError.response.data === "string"
          ? axiosError.response.data
          : "Unknown error";
      if (axiosError && axiosError.status === 401) {
        requestPayload.navigateToLogout("/logout");
        return {
          status: false,
          message: "UnAuthrized",
        };
      } else {
        return {
          status: false,
          message: errorMessage,
        };
      }
    }
  },
  delTrust: async (
    delPayload: any,
  ): Promise<string | IServerError | IResponse | any> => {
    // return new Promise(resolve => setTimeout(() => resolve("Flex Field has been deleted successfully"), 1000));
    try {
      const response: AxiosResponse<string> = await http.delete<string>(
        `/v1/trust-bank-setup/${delPayload.trustBankId}`,
      );

      if (response.status === 200) {
        return "Trust Bank has been deleted successfully";
      } else if (response.status === 500) {
        return {
          status: false,
          message: "Something went wrong.",
          error: true,
        };
      }

      return {
        status: false,
        message: "Something went wrong please try again later.",
      };
    } catch (error) {
      const axiosError = error as AxiosError;
      console.error("An error occurred:", axiosError);
      const errorMessage =
        axiosError.response && typeof axiosError.response.data === "string"
          ? axiosError.response.data
          : "Unknown error";
      if (axiosError && axiosError.status === 401) {
        delPayload.navigateToLogout("/logout");
        return {
          status: false,
          message: "UnAuthrized",
        };
      } else {
        return {
          status: false,
          message: errorMessage,
        };
      }
    }
  },
  archiveTrustBank: async (
    archivePayload: any,
  ): Promise<string | IServerError | IResponse | any> => {
    try {
      const response: AxiosResponse<string> = await http.post<string>(
        `/v1/employee-bank/${archivePayload.trustId}/`,
      );

      if (response.status === 201) {
        return "Employee Bank has been archived successfully";
      } else if (response.status === 200) {
        return "Employee Bank has been archived successfully";
      } else if (response.status === 500) {
        return {
          status: false,
          message: "Something went wrong.",
          error: true,
        };
      }

      return {
        status: false,
        message: "Something went wrong please try again later.",
      };
    } catch (error) {
      const axiosError = error as AxiosError;
      console.error("An error occurred:", axiosError);
      const errorMessage =
        axiosError.response && typeof axiosError.response.data === "string"
          ? axiosError.response.data
          : "Unknown error";
      if (axiosError && axiosError.status === 401) {
        archivePayload.navigateToLogout("/logout");
        return {
          status: false,
          message: "UnAuthrized",
        };
      } else {
        return {
          status: false,
          message: errorMessage,
        };
      }
    }
  },
  getTrustDDL: async (): Promise<any | IServerError | IResponse | null> => {
    const response: AxiosResponse<any[]> = await http.get<any[]>(
      `/v1/trust-bank-setup/ddl`,
    );

    if (response.status === 200) {
      return response.data;
    }

    return {
      status: false,
      message: "Something went wrong please try again later.",
    };
  },
};
